import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/productSlice";

import productApis from "src/api/product";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

// create product saga
const CreateProductSaga = function* CreateProductSaga({
  payload,
}: ReturnType<typeof actions.createProductRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      productApis.createProduct,
      payload
    );

    yield put(actions.createProductSuccess(response));
  } catch (error) {
    yield put(
      actions.createProductError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// get product list saga
const GetProductListSaga = function* GetProductListSaga({
  payload,
}: ReturnType<typeof actions.getProductListRequest> & {
  payload: {
    page: number;
    limit: number;
    status?: "active" | "inactive";
    search?: string;
    categoryId?: string;
    brandId?: string;
    unitId?: string;
  };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      productApis.getProductList,
      payload
    );

    yield put(actions.getProductListSuccess(response));
  } catch (error) {
    yield put(
      actions.getProductListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// ✅ Edit Product Saga
function* EditProductSaga({
  payload,
}: ReturnType<typeof actions.editProductRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      productApis.editProduct,
      payload
    );
    yield put(actions.editProductSuccess(response));
  } catch (error) {
    yield put(
      actions.editProductError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Delete Product Saga
function* DeleteProductSaga({
  payload,
}: ReturnType<typeof actions.deleteProductRequest> & { payload: string }) {
  try {
    const response: common.ResponseGenerator = yield call(
      productApis.deleteProduct,
      payload
    );
    yield put(actions.deleteProductSuccess(response));
  } catch (error) {
    yield put(
      actions.deleteProductError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Get Single Product Saga
function* GetProductSaga({
  payload,
}: ReturnType<typeof actions.getProductRequest> & { payload: string }) {
  try {
    const response: common.ResponseGenerator = yield call(
      productApis.getProduct,
      payload
    );
    yield put(actions.getProductSuccess(response));
  } catch (error) {
    yield put(
      actions.getProductError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* productSaga() {
  yield all([
    takeEvery(actions.createProductRequest, CreateProductSaga),
    takeEvery(actions.getProductListRequest, GetProductListSaga),
    takeEvery(actions.editProductRequest, EditProductSaga),
    takeEvery(actions.deleteProductRequest, DeleteProductSaga),
    takeEvery(actions.getProductRequest, GetProductSaga),
  ]);
}
